import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { AwsService } from "../../../providers/appsyncservice/aws.service";
import { positions } from "../../../models/positions";
declare var google: any;
import * as XLSX from "xlsx";
import * as jsPDF from "jspdf";
@Component({
  selector: "app-sc-user-trip",
  templateUrl: "./sc-user-trip.component.html",
  styleUrls: ["./sc-user-trip.component.css"],
})
export class ScUserTripComponent implements OnInit {
  tripsList: any = [];
  nextToken: String = "";
  cabs: any = [];
  scheduled_date: String = "";
  disbaleUpdate: boolean = false;
  key: string = "scheduled_date"; //set default
  reverse: boolean = false;
  user_id: String = "";
  typeList: any = [];
  statusList: any = [];
  usertripFm: FormGroup;
  submitted: boolean = false;
  errorMessage: string;
  errorType: boolean = false;
  id: String = "";
  vhclMstLt: any[];
  vhclMst: any;
  editvehicle: any;
  displayValue: Number = 0;
  cabmaster: any;
  tripusers: any;
  driverDropdownSettings = {};
  geofence_limit: Number;
  positionHome: any;
  positionOffcie: any;
  user_Home_Address: string;
  trip_status: string;
  user_name: string;
  user_Office_Address: any;
  vehicle_model: string;
  trip_type: string;
  buttonval: number = 1;
  managerEmp: any;
  buttonValue: String;
  tempEditData: any = {};
  lat: number = 12.7369761;
  lng: number = 80.0066669;
  homelat: number = 12.73377;
  homelong: number = 80.011268;
  officelat: number = 12.73377;
  officelong: number = 80.011268;
  homeAddress: String = "-";
  officeAddress: String = "RNTBCI";
  next: String = "";
  homeMarker = {};
  officeMarker = {};
  markers = [];
  centerPosition = { lat: 12.73377, lng: 80.011268 };

  constructor(
    public awserviceProvider: AwsService,
    private formBuilder: FormBuilder
  ) {
    this.getAllData();
    //get Driver List
    this.awserviceProvider.RncUsersAll().then((tripusers) => {
      console.log("tripusers", tripusers);
      this.tripusers = tripusers;
    });

    // //get Cab List
    // this.awserviceProvider.getScCabMasterAll().then(cabs => {
    //   console.log("tripusers", cabs);
    //   var cabslist: any = []
    //   cabslist = cabs;
    //   console.log(cabslist, "cabslist")
    //   cabslist.forEach(cab => {
    //     this.awserviceProvider.getRncUsers(cab.driver_id).then(driver => {
    //       cab.driver = {};
    //       cab.driver = driver;
    //       this.cabs.push(cab)
    //     });
    //   });
    // });
    // this.awserviceProvider.getEmployeeUser().then(result => {
    //   this.managerEmp = result;
    // });
  }
  getAllData() {
    this.tripsList = [];
    let dateFormat = require("dateformat");
    this.scheduled_date = dateFormat(new Date(), "yyyy-mm-dd");
    this.awserviceProvider
      .getScUserTripByDriverAll(this.scheduled_date)
      .then((tripslist) => {
        var trips: any = tripslist;
        trips.forEach((trip) => {
          this.awserviceProvider.getRncUsers(trip.user_id).then((user) => {
            trip.user = {};
            trip.user = user;
          });
          this.tripsList.push(trip);
        });
        this.sortinglist();
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  exportToExcel() {
    let exportJsonTemp = [];

    exportJsonTemp = this.exportJsonFormation(this.tripsList);
    const workBook = XLSX.utils.book_new(); // create a new blank book

    const workSheet = XLSX.utils.json_to_sheet(exportJsonTemp);

    // console.log("EXCEL", exportJsonTemp);
    XLSX.utils.book_append_sheet(workBook, workSheet, "data"); // add the worksheet to the book
    XLSX.writeFile(workBook, "User_Trips.xlsx");
  }

  exportToPdf() {
    console.log("exportToPdf");
    //this.spinnerService.show();
    var getColumns = [
      { title: "Scheduled date", dataKey: "scheduled_date" },
      { title: "User", dataKey: "user_name" },
      { title: "Is Driver", dataKey: "is_driver" },
      { title: "Trip Type", dataKey: "trip_type" },
      { title: "Trip Status", dataKey: "trip_status" },
      { title: "OTP", dataKey: "otp" },
      { title: "Boarding Status", dataKey: "is_boarded" },
      { title: "Present/Absent", dataKey: "present_status" },
      { title: "Drop Point", dataKey: "drop_point" },
      { title: "Start Address", dataKey: "start_address" },
      { title: "End Address", dataKey: "end_address" },
    ];

    var pdfsize = "a4";
    var doc = new jsPDF("l", "pt", pdfsize);

    doc.text(20, 20, "SAFEcab Users Trips");
    let exportJsonTemp = [];
    exportJsonTemp = this.exportJsonFormation(this.tripsList);
    doc.autoTable(getColumns, exportJsonTemp, {
      startY: 40,
      // startX: 20,
      tableLineColor: [189, 195, 199],
      tableLineWidth: 0.75,
      styles: {
        font: "Times New Roman",
        fillColor: [217, 217, 217],
        lineColor: [189, 195, 199],
        lineWidth: 0.25,
        textColor: 0,
        overflow: "linebreak",
        columnWidth: "wrap",
      },
      headerStyles: {
        fillColor: [217, 217, 217],
        textColor: 0,
        overflow: "linebreak",
        columnWidth: "wrap",
      },
      columnStyles: {
        text: { overflow: "linebreak" }, //columnWidth: 'wrap' },
        user_name: { cellWidth: 60, overflow: "linebreak" },
        start_address: { cellWidth: 100, overflow: "linebreak" },
        end_address: { cellWidth: 100, overflow: "linebreak" },
        is_boarded: { cellWidth: 20, overflow: "linebreak" },
        present_status: { cellWidth: 20, overflow: "linebreak" },
      },
    });
    doc.save("SAFEcab User Trips.pdf");
  }

  exportJsonFormation(trips) {
    let dateFormat = require("dateformat");
    let exportJsonTemp = [];

    trips.forEach((trip) => {
      let exJson: any = {};

      exJson.scheduled_date = dateFormat(
        trip.scheduled_date,
        "yyyy-mm-dd HH:MM:ss"
      ); //new Date(trip.scheduled_date).toLocaleString();
      exJson.user_name = trip.user != null ? trip.user.name : "";
      exJson.user_id = trip.user != null ? trip.user.user_name : "";
      exJson.is_driver =
        trip.user != null && trip.user.user_type == 2 ? "Yes" : "";
      exJson.trip_type = trip.trip_type == 0 ? "Pick Up" : "Drop";
      exJson.trip_status =
        trip.trip_status == 0
          ? "Not Started"
          : trip.trip_status == 1
          ? "Started"
          : "Completed";
      exJson.otp = trip.otp;
      exJson.is_boarded = trip.is_boarded == true ? "Yes" : "No";
      exJson.present_status = trip.is_boarded == true ? "Present" : "Absent";
      exJson.drop_point = trip.drop_point;
      exJson.start_address = trip.start_address.address;
      exJson.end_address = trip.end_address.address;

      exportJsonTemp.push(exJson);
    });

    return exportJsonTemp;
  }

  ngOnInit() {
    this.statusList = [
      {
        id: 0,
        name: "Not Started",
      },
      {
        id: 1,
        name: "Started",
      },
      {
        id: 2,
        name: "Completed",
      },
    ];
    this.typeList = [
      {
        id: 0,
        name: "Pickup",
      },
      {
        id: 1,
        name: "Drop",
      },
    ];
    // this.editvehicle={};
    this.buttonValue = "";
    this.displayValue = 0;
    this.user_id = "";
    this.trip_type = "";
    this.scheduled_date = "";
    this.trip_status = "";
    this.vhclMstLt = [];
    this.tripusers = [];
    this.cabs = [];
    this.driverDropdownSettings = {
      singleSelection: true,
      idField: "id",
      textField: "id",
      itemsShowLimit: 5,
      allowSearchFilter: true,
    };
    this.formInitilization();
  }

  formInitilization() {
    this.usertripFm = new FormGroup({
      id: new FormControl(""),
      scheduled_date: new FormControl("", Validators.required),
      user_id: new FormControl("", Validators.required),
      otp: new FormControl("", Validators.required),
      trip_type: new FormControl("", Validators.required),
      trip_status: new FormControl("", Validators.required),
      is_boarded: new FormControl("", Validators.required),
      drop_point: new FormControl("", Validators.required),
      start_address: new FormControl("", Validators.required),
      end_address: new FormControl("", Validators.required),
    });

    let dateFormat = require("dateformat");
    this.scheduled_date = dateFormat(new Date(), "yyyy-mm-dd");
  }

  get f() {
    return this.usertripFm.controls;
  }
  reset() {
    this.formInitilization();
  }
  async onSubmit() {
    // alert(this.usertripFm.invalid)
    this.submitted = true;
    if (this.usertripFm.invalid) {
      return;
    }
    this.disbaleUpdate = true;

    console.log(this.usertripFm.value);

    await this.getGeoLocation(this.usertripFm.value.start_address).then(
      async (st) => {
        let stposition: any = {};
        stposition.lat = st.latitude;
        stposition.long = st.longitude;

        await this.getGeoLocation(this.usertripFm.value.start_address).then(
          async (end) => {
            let endposition: any = {};
            endposition.lat = st.latitude;
            endposition.long = st.longitude;

            this.awserviceProvider.UpdateScUserTrips(
              this.usertripFm.value,
              stposition,
              endposition
            );
            this.getAllData();
            this.displayValue = 0;
          }
        );
      }
    );
    // this.awserviceProvider.updateVehicleMaster(this.usertripFm.value).then(res => {
    //   this.vhclMstLt.unshift(this.usertripFm.value);
    //   this.displayValue = 0;
    //   //  this.getAllData();
    // }).catch(err => {
    //   this.errorType = true;
    //   console.log(err);
    //   // alert("update failed");
    //   this.errorMessage = "Unable to add the data. Please contact system administrator"
    // });
  }

  search(searchData) {
    this.nextToken = "";
    this.searchFilter(searchData);
  }

  searchFilter(searchData) {
    if (this.nextToken == "") {
      this.tripsList = [];
    }

    this.awserviceProvider
      .ScUserTripFilter(searchData, this.nextToken)
      .then((res: any) => {
        if (res.nextToken != null) {
          this.nextToken = res.nextToken;
          console.log("this.nextToken", this.nextToken);
          this.searchFilter(searchData);
        }

        var trips: any = res.items;
        trips.forEach((trip) => {
          this.awserviceProvider.getRncUsers(trip.user_id).then((user) => {
            trip.user = {};
            trip.user = user;
          });
          this.tripsList.push(trip);
        });
        this.sortinglist();
      })
      .catch((err) => {
        console.log("err", err);
      });
  }
  editData(usertrip: any) {
    this.buttonValue = "Update";
    this.disbaleUpdate = false;
    this.displayValue = 1;
    this.usertripFm.setValue({
      id: usertrip.id,
      user_id: usertrip.user.name,
      trip_status: usertrip.trip_status,
      trip_type: usertrip.trip_type,
      otp: usertrip.otp,
      is_boarded: usertrip.is_boarded,
      drop_point: usertrip.drop_point,
      scheduled_date: usertrip.scheduled_date,
      end_address: usertrip.end_address.address,
      start_address: usertrip.start_address.address,
    });
  }
  setName(name) {
    this.user_name = name;
    // alert(name);
  }
  deleteData(usertrip) {
    this.awserviceProvider
      .deleteScUserTrip(usertrip.id)
      .then((res) => {
        this.getAllData();
      })
      .catch((err) => {
        console.log(err);
      });
  }
  add() {
    this.formInitilization();
    this.buttonValue = "Save";
    this.displayValue = 1;
  }

  async getGeoLocation(address: string): Promise<any> {
    console.log("address", address);
    let myPromise = await new Promise((resolve, reject) => {
      setTimeout(() => {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: address }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            var lat = results[0].geometry.location.lat();
            var lng = results[0].geometry.location.lng();
            // // console.log("lat", lat)
            // // console.log("lat", lng)
            var pos = new positions();
            pos.latitude = lat;
            pos.longitude = lng;
            resolve(pos);
            console.log("GeoLocation found");
          } else {
            console.log("geo locaton status error--", status, results);
            reject(status);
          }
        });
      }, 2300);
    });
    return myPromise;
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  sortinglist() {
    const sorted = this.tripsList.sort((t1, t2) => {
      const date1 = t1.scheduled_date;
      const date2 = t2.scheduled_date;
      var start = new Date(date1).getTime();
      var end = new Date(date2).getTime();

      if (start > end) {
        return -1;
      }
      if (start < end) {
        return 1;
      }
      return 0;
    });

    this.tripsList = sorted;
  }

  // sortBy(propertyName) {
  //   this.reverse = (this.propertyName === propertyName) ? this.reverse : false;
  //   this.propertyName = propertyName;
  // };
}
